// OP-3619 — Campo de serial ou patrimônio com o botão da câmera ao lado.
//
// A câmera é um teclado: o que ela lê vai para o mesmo campo que o operador
// digitaria, e daí segue o mesmo caminho — a mesma busca, a mesma validação.
// Quem precisa de outro destino (abrir a peça, por exemplo) passa `aoLer`.
import { CSSProperties, FC, useState } from 'react'
import styled from 'styled-components'
import { CameraScanner } from '../../../components/CameraScanner'
import { BotaoIcone, Input } from '../styles'
import { normalizarCodigo } from './leitura'
import { useCameraDisponivel } from './useCameraDisponivel'

const Linha = styled.div`
  display: flex;
  align-items: stretch;
  gap: 8px;
  & > input {
    flex-grow: 1;
    min-width: 0;
  }
`

export const IconeCamera: FC = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M4 8h3l2-3h6l2 3h3v11H4z" />
    <circle cx="12" cy="13" r="3.5" />
  </svg>
)

export interface CampoComLeitorProps {
  valor: string
  aoMudar: (valor: string) => void
  /** Título da tela da câmera: diz o que está sendo lido. */
  tituloLeitor: string
  aoLer?: (codigo: string) => void
  /** Enter no campo; a leitura da câmera não dispara isto. */
  aoConfirmar?: () => void
  placeholder?: string
  rotulo?: string
  maxLength?: number
  disabled?: boolean
  style?: CSSProperties
}

export const CampoComLeitor: FC<CampoComLeitorProps> = ({
  valor, aoMudar, tituloLeitor, aoLer, aoConfirmar, placeholder, rotulo, maxLength = 80, disabled, style,
}) => {
  const comCamera = useCameraDisponivel()
  const [lendo, setLendo] = useState(false)

  const lido = (codigo: string) => {
    setLendo(false)
    const c = normalizarCodigo(codigo)
    if (aoLer) aoLer(c)
    else aoMudar(c)
  }

  return (
    <>
      <Linha style={style}>
        <Input
          value={valor}
          placeholder={placeholder}
          aria-label={rotulo ?? placeholder}
          maxLength={maxLength}
          disabled={disabled}
          onChange={(e) => aoMudar(e.target.value)}
          onKeyDown={aoConfirmar ? (e) => { if (e.key === 'Enter') aoConfirmar() } : undefined}
        />
        {comCamera && (
          <BotaoIcone type="button" aria-label="Ler com a câmera" title="Ler com a câmera" disabled={disabled} onClick={() => setLendo(true)}>
            <IconeCamera />
          </BotaoIcone>
        )}
      </Linha>
      {lendo && (
        <CameraScanner
          title={tituloLeitor}
          hint="Aponte para o código de barras ou o QR da etiqueta."
          manualLabel="Digitar"
          onScan={lido}
          onClose={() => setLendo(false)}
          onManual={() => setLendo(false)}
        />
      )}
    </>
  )
}

export default CampoComLeitor
